import React, { useState, useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { getuserdata } from "../../services/apiService";

// Fix for default markers in react-leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const Defaultlocation = ({ selectedCountry, setSelectedCountry, searchAddress, setSearchAddress, mapCenter, setMapCenter, userdata }) => {
    const [selectedLocation, setSelectedLocation] = useState(mapCenter);
    const [countries, setCountries] = useState([]);
    const [manualLat, setManualLat] = useState(mapCenter?.lat || '');
    const [manualLng, setManualLng] = useState(mapCenter?.lng || '');
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [showSearchResults, setShowSearchResults] = useState(false);
    const searchRef = useRef(null);

    useEffect(() => {
        fetchCountries();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSearchResults(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const fetchCountries = async () => {
        try {
            const response = await fetch('https://restcountries.com/v3.1/all?fields=name,cca2,flags');
            const data = await response.json();
            const formattedCountries = data
                .map(country => ({
                    name: country.name.common,
                    code: country.cca2.toLowerCase(),
                    flag: country.flags.png
                }))
                .sort((a, b) => a.name.localeCompare(b.name));
            setCountries(formattedCountries);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };

    const handleCountryChange = async (e) => {
        const countryCode = e.target.value;
        const country = countries.find(c => c.code === countryCode);
        setSelectedCountry(countryCode);
        if (country) {
            try {
                const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(country.name)}&limit=1`);
                const data = await response.json();
                if (data && data.length > 0) {
                    const lat = parseFloat(data[0].lat);
                    const lng = parseFloat(data[0].lon);
                    setMapCenter({ lat, lng });
                    setSelectedLocation({ lat, lng });
                    setSearchAddress(data[0].display_name);
                    setManualLat(lat.toString());
                    setManualLng(lng.toString());
                }
            } catch (error) { console.error('Error geocoding:', error); }
        }
    };

    const searchLocation = async (query) => {
        if (!query.trim()) return;
        try {
            const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=5&addressdetails=1`);
            const data = await response.json();
            setSearchResults(data);
            setShowSearchResults(true);
        } catch (error) { console.error('Error searching:', error); }
    };

    const selectSearchResult = (result) => {
        const lat = parseFloat(result.lat);
        const lng = parseFloat(result.lon);
        setMapCenter({ lat, lng });
        setSelectedLocation({ lat, lng });
        setSearchAddress(result.display_name);
        setManualLat(lat.toString());
        setManualLng(lng.toString());
        setShowSearchResults(false);
        setSearchQuery(result.display_name);
        if (result.address && result.address.country_code) {
            setSelectedCountry(result.address.country_code.toLowerCase());
        }
    };

    const updateLocationFromLatLng = async (lat, lng) => {
        setMapCenter({ lat, lng });
        setSelectedLocation({ lat, lng });
        try {
            const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&addressdetails=1`);
            const data = await response.json();
            if (data && data.display_name) {
                setSearchAddress(data.display_name);
                setSearchQuery(data.display_name);
                if (data.address && data.address.country_code) {
                    setSelectedCountry(data.address.country_code.toLowerCase());
                }
            }
        } catch (error) { console.error('Error reverse geocoding:', error); }
    };

    const MapClickHandler = () => {
        useMapEvents({
            click(e) {
                updateLocationFromLatLng(e.latlng.lat, e.latlng.lng);
                setManualLat(e.latlng.lat.toString());
                setManualLng(e.latlng.lng.toString());
            },
        });
        return null;
    };

    return (
        <div className="dc-tabscontent tab-content">
            <style>{`
                .location-card {
                    background: #fff;
                    border-radius: 12px;
                    border: 1px solid #e5e7eb;
                    padding: 24px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
                }
                .map-wrapper {
                    border-radius: 12px;
                    overflow: hidden;
                    border: 1px solid #e5e7eb;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
                    margin-bottom: 25px;
                }
                .location-label {
                    font-size: 13px;
                    font-weight: 600;
                    color: #374151;
                    margin-bottom: 8px;
                    display: block;
                }
                .premium-input {
                    height: 48px !important;
                    border-radius: 8px !important;
                    border: 1px solid #d1d5db !important;
                    font-size: 14px !important;
                    padding: 10px 15px !important;
                    transition: all 0.2s ease;
                }
                .premium-input:focus {
                    border-color: var(--themecolor) !important;
                    box-shadow: 0 0 0 3px rgba(var(--themecolor-rgb), 0.1) !important;
                    outline: none;
                }
                .search-group {
                    display: flex;
                    gap: 8px;
                }
                .search-btn {
                    height: 48px;
                    border-radius: 8px;
                    background: var(--themecolor);
                    color: white;
                    border: none;
                    padding: 0 20px;
                    font-weight: 600;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    transition: all 0.2s ease;
                }
                .search-btn:hover {
                    opacity: 0.9;
                    transform: translateY(-1px);
                }
                .search-results-dropdown {
                    position: absolute;
                    top: 100%;
                    left: 15px;
                    right: 15px;
                    background: white;
                    border: 1px solid #e5e7eb;
                    border-radius: 8px;
                    z-index: 1000;
                    margin-top: 5px;
                    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
                    max-height: 250px;
                    overflow-y: auto;
                }
                .search-result-item {
                    padding: 12px 15px;
                    cursor: pointer;
                    font-size: 13px;
                    border-bottom: 1px solid #f3f4f6;
                    transition: background 0.2s;
                }
                .search-result-item:hover {
                    background: #f9fafb;
                }
                .search-result-item:last-child {
                    border-bottom: none;
                }
                .coordinate-group {
                    background: #f9fafb;
                    padding: 20px;
                    border-radius: 10px;
                    border: 1px solid #f3f4f6;
                    margin-top: 10px;
                }
            `}</style>

            <div className="dc-personalskillshold tab-pane active fade show">
                <div className="dc-skills dc-tabsinfo" style={{ padding: '0' }}>
                    <div className="dc-tabscontenttitle mb-4">
                        <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#111827' }}>Default Location</h3>
                        <p className="text-muted small">Select your country and search for your specific address or drag the marker on the map.</p>
                    </div>

                    <div className="location-card">
                        <div className="map-wrapper">
                            <MapContainer
                                center={[mapCenter.lat, mapCenter.lng]}
                                zoom={13}
                                style={{ height: '400px', width: '100%' }}
                            >
                                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                <MapClickHandler />
                                <Marker
                                    position={[selectedLocation.lat, selectedLocation.lng]}
                                    draggable={true}
                                    eventHandlers={{
                                        dragend: (e) => {
                                            const { lat, lng } = e.target.getLatLng();
                                            updateLocationFromLatLng(lat, lng);
                                            setManualLat(lat.toString());
                                            setManualLng(lng.toString());
                                        }
                                    }}
                                />
                            </MapContainer>
                        </div>

                        <div className="row g-4">
                            <div className="col-md-6 mb-3">
                                <label className="location-label">Country</label>
                                <div className="dc-select">
                                    <select
                                        value={selectedCountry}
                                        onChange={handleCountryChange}
                                        className="form-control premium-input"
                                        style={{ appearance: 'none' }}
                                    >
                                        <option value="">Select Country</option>
                                        {countries.map(country => (
                                            <option key={country.code} value={country.code}>{country.name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-6 mb-3" ref={searchRef} style={{ position: 'relative' }}>
                                <label className="location-label">Search Address</label>
                                <div className="search-group">
                                    <input
                                        type="text"
                                        className="form-control premium-input"
                                        placeholder="Enter your address..."
                                        value={searchQuery || searchAddress}
                                        onChange={(e) => { setSearchQuery(e.target.value); setSearchAddress(e.target.value); }}
                                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); searchLocation(searchQuery); } }}
                                        style={{ flex: 1 }}
                                    />
                                    <button
                                        type="button"
                                        className="search-btn"
                                        onClick={() => searchLocation(searchQuery)}
                                    >
                                        <i className="ti-search"></i> Search
                                    </button>
                                </div>
                                {showSearchResults && searchResults.length > 0 && (
                                    <div className="search-results-dropdown">
                                        {searchResults.map((result, idx) => (
                                            <div
                                                key={idx}
                                                className="search-result-item"
                                                onClick={() => selectSearchResult(result)}
                                            >
                                                <i className="ti-location-pin me-2 text-muted"></i>
                                                {result.display_name}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="coordinate-group">
                            <div className="row">
                                <div className="col-md-6">
                                    <label className="location-label">
                                        <i className="ti-target me-1 text-primary"></i> Latitude
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control premium-input"
                                        value={manualLat}
                                        onChange={(e) => setManualLat(e.target.value)}
                                        placeholder="0.000000"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="location-label">
                                        <i className="ti-target me-1 text-primary"></i> Longitude
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control premium-input"
                                        value={manualLng}
                                        onChange={(e) => setManualLng(e.target.value)}
                                        placeholder="0.000000"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Defaultlocation;
